import React from 'react';

import { Box, Button, Link } from "@material-ui/core";
import History from '@material-ui/icons/History';
import BrowserHistory from 'react-router/';
import { useTranslate } from 'react-admin';
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    icon: {
        height: '9em',
        width: '9em',
        fontSize: '1.1785714285714286rem',
        fill: 'grey'
    },
    button: {
        margin: '3em',
        "&:hover": {
            textDecoration: 'none'
        },
        fontFamily: 'UniviaPro-Bold',
        fontSize: '13px',
        fontWeight: 'bold',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 'normal',
        letterSpacing: ' 0.44px',

    }
}));

export default function Error(props) {
    const translate = useTranslate();
    const classes = useStyles();
    return (
        <Box width='100%' display='flex' justifyContent='center'>
            <Box width='100%' textAlign='center'>
                <svg className={classes.icon} focusable="false" viewBox="0 0 24 24" aria-hidden="true" role="presentation">
                    <circle cx="7" cy="6" r="2"></circle>
                    <path d="M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z">
                    </path>
                </svg>
                <h1 style={{ fontFamily: 'Roboto, sans-serif', color: 'grey' }}> {translate('pos.auth.NotFound')}</h1>
                <Box style={{ fontFamily: 'Roboto, sans-serif', opacity: '0.5' }}> {translate('pos.auth.ConstentNotFound')}</Box>
                <Button
                    variant="contained"
                    icon={<History />}
                    className={classes.button}

                    component={Link}
                    href="/"
                >
                    {translate('pos.auth.GoHome')}
                </Button>
            </Box>
        </Box>

    );
}
